import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import Chart, { ChartConfiguration } from 'chart.js/auto';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements AfterViewInit, OnChanges, OnDestroy {

  @Input() config: ChartConfiguration | null = null;

  // Altura fija del contenedor. Por defecto 280px (acuerdo D8 del plan).
  // Si el caller necesita otra altura puede sobrescribirla.
  @Input() height = 280;

  @ViewChild('canvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;

  private chart: Chart | null = null;

  ngAfterViewInit(): void {
    this.createChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Sólo reaccionar cuando la instancia ya existe (post AfterViewInit).
    // En el primer ciclo `ngOnChanges` corre antes que `ngAfterViewInit`, por
    // eso allí no creamos: se delega al hook de view.
    if (!this.chart) return;
    if (!changes['config']) return;

    if (!this.config) {
      this.chart.destroy();
      this.chart = null;
      return;
    }

    // Patrón `update()`: muta data + options en sitio en vez de recrear.
    // Evita flicker y respeta cualquier animación en curso.
    this.chart.data = this.config.data;
    if (this.config.options) {
      this.chart.options = this.config.options;
    }
    this.chart.update();
  }

  ngOnDestroy(): void {
    this.chart?.destroy();
    this.chart = null;
  }

  private createChart(): void {
    if (!this.config) return;
    if (!this.canvasRef?.nativeElement) return;
    this.chart = new Chart(this.canvasRef.nativeElement, this.config);
  }
}
